import React from 'react';
import { Filter as FilterAdmin, TextInput } from 'react-admin';

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="descricao" />
  </FilterAdmin>
);

export default Filter;
